import styled, { keyframes } from 'styled-components';

export const StyledControlSectionContainer = styled.div`
  height: 400px;
  padding: 20px 10px; // мое
`;

export const StyledControlSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const StyledHeaderLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #404851;
  margin: 0;
  line-height: 1.4;
`;

export const StyledHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StyledControlListItem = styled.li<{ highlighted?: boolean }>`
  padding: 10px 0;

  ${props =>
    !props.highlighted
      ? `background-color:white; cursor: pointer;`
      : `background-color:#faebd7; pointer-events: none;`}
  :hover {
    color: #206fe2;
    background-color: #f8faff;
  }
`;

export const StyledSearchWrapper = styled.div`
  width: 100%;
`;

export const StyledSearchIcon = styled.div`
  height: 18px;
`;

export const StyledDragWrapper = styled.div`
  display: flex;
`;

export const StyledStatusOrder = styled.div`
  margin-right: 5px;
  font-weight: 500;
`;

export const StyledHeaderButtonsWrapper = styled.div`
  display: flex;

  > div {
    margin-left: 10px;
  }
`;

export const StyledSortContainer = styled.div`
  cursor: pointer;
`;

const grow = keyframes`
   0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
`;

export const StyledSeparator = styled.div`
  height: 4px;
  background-color: #007bff;
  margin: 5px 0;
  border-radius: 2px;
  animation: ${grow} 0.3s ease-in-out forwards;
`;
